import { WebPlugin } from "@capacitor/core";
export class NativeBiometricWeb extends WebPlugin {
    constructor() {
        super();
    }
    isAvailable() {
        throw new Error("Method not implemented.");
    }
    verifyIdentity(_options) {
        console.log("verifyIdentity", _options);
        throw new Error("Method not implemented.");
    }
    getCredentials(_options) {
        console.log("getCredentials", _options);
        throw new Error("Method not implemented.");
    }
    setCredentials(_options) {
        console.log("setCredentials", _options);
        throw new Error("Method not implemented.");
    }
    deleteCredentials(_options) {
        console.log("deleteCredentials", _options);
        throw new Error("Method not implemented.");
    }
}
//# sourceMappingURL=web.js.map